export default __webpack_public_path__ + "static/media/Ramadan_V2_1440x300.a3b77e34.jpg";